import { useContext, useEffect, useRef, useState } from "react";
import Gallery from "react-photo-gallery";
import ImageRenderer from "./ImageRenderer";
import { Container } from "react-bulma-components";
import StateContext from "../context/StateContext";
import styled from "styled-components";
import { Modal } from "react-bulma-components";
import { careCalendarMediaUrl } from "./Utilities";

const RickrolledVideo = styled.video`
  position: absolute;
  width: 100%;
  left: 50%;
  top: 50%;
  height: 100%;
  objectfit: cover;
  transform: translate(-50%, -50%);
  zindex: +1;
`;

const StyledModalCard = styled(Modal.Card)`
  box-shadow: inset 10px 10px 5px ${(props) => props.theme.primary};
  overflow-x: visible;
  overflow-y: visible;
`;

const BgModalCardBody = styled(Modal.Card.Body)`
  box-shadow: inset -10px -10px 5px ${(props) => props.theme.primary};
  background: ${(props) => props.theme.background};
`;

function EventPage({ media, ...props }) {
  var [playingVideo, setPlayingVideo] = useState("none");
  var [videoPath, setVideoPath] = useState("");
  const [, dispatch] = useContext(StateContext);
  const videoRef = useRef(null);
  const rrVideoRef = useRef(null);

  useEffect(() => {
    if (playingVideo === "rickrolled" && rrVideoRef) {
      const currentNode = rrVideoRef.current;
      const handleVideoEnd = () => {
        setPlayingVideo("none");
        currentNode.removeEventListener("ended", handleVideoEnd);
      };
      rrVideoRef.current.addEventListener("ended", handleVideoEnd);
    }
  }, [playingVideo, videoPath]);

  var mediaItems = media.videos
    .map((vid) => {
      return {
        src:
          media.directory === ""
            ? careCalendarMediaUrl(vid.thumb, media.index)
            : careCalendarMediaUrl(vid.thumb, media.index, media.directory),
        width: vid.thumb_width,
        height: vid.thumb_height,
        mediatype: "video",
        rickrolled: vid.rickrolled,
        videosrc:
          media.directory === ""
            ? careCalendarMediaUrl(vid.filename, media.index)
            : careCalendarMediaUrl(vid.filename, media.index, media.directory),
      };
    })
    .concat(
      media.images.map((img) => {
        return {
          src:
            media.directory === ""
              ? careCalendarMediaUrl(img.filename, media.index)
              : careCalendarMediaUrl(
                  img.filename,
                  media.index,
                  media.directory
                ),
          width: img.width,
          height: img.height,
          mediatype: "photo",
        };
      })
    );

  return (
    <>
      <Container mb="6">
        <Gallery
          targetRowHeight={media.targetRows}
          photos={mediaItems}
          renderImage={ImageRenderer}
          onClick={(event, data) => {
            if (data.photo.mediatype === "video") {
              setVideoPath(data.photo.videosrc);
              if (data.photo.rickrolled) {
                setPlayingVideo("rickrolled");
                dispatch({ type: "watchedRickrolledVideo" });
              } else {
                setPlayingVideo("modal");
                dispatch({ type: "watchedVideo" });
              }
            }
          }}
        ></Gallery>
      </Container>
      <Modal
        show={playingVideo === "modal"}
        onClose={() => {
          setPlayingVideo("none");
        }}
      >
        <StyledModalCard>
          <BgModalCardBody>
            <video controls autoPlay width="640" height="480" ref={videoRef}>
              <source type="video/mp4" src={videoPath}></source>
            </video>
          </BgModalCardBody>
        </StyledModalCard>
      </Modal>
      {playingVideo === "rickrolled" && (
        <RickrolledVideo autoPlay width="640" height="480" ref={rrVideoRef}>
          <source type="video/mp4" src={videoPath}></source>
        </RickrolledVideo>
      )}
    </>
  );
}

// function EventPage({ media, ...props }) {
//   var mediaItems = media.images.map((img) => {
//     return {
//       src: GetFilename(media.index, img.filename),
//       width: img.width,
//       height: img.height,
//       mediatype: "photo",
//     };
//   });

//   console.log(media);
//   return (
//     <Container mb="6">
//       <Gallery
//         targetRowHeight={media.targetRows}
//         photos={mediaItems}
//       ></Gallery>
//     </Container>
//   );
// }

export default EventPage;
